import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

import {
    getFormattedMedicalPaymentCoverageAmount,
    getFormattedPersonalLiabilityCoverageAmount
} from 'common/source/utilities/policyInfoDisplay';
import { CurrentUserService } from 'services/currentUser';
import { isDp3Policy } from 'common/source/utilities/policyInfoHelper';

const module = angular.module('coverage-personal-liability-section', []);

interface HomeCoverage extends NameAndValue {
    tooltipContent?: string;
}

interface CoveragePersonalLiabilitySectionController extends angular.IStrictController {
    title: string;
    icon: string;
    description: string;
    coverages: Array<HomeCoverage>;
}

module.component('coveragePersonalLiabilitySection', {
    template: template,
    controller: function(
        this: CoveragePersonalLiabilitySectionController,
        currentUserService: CurrentUserService,
        $stateParams: PolicyStateParams
    ) {
        'ngInject';

        this.$onInit = () => {
            this.title = 'Personal Liability';
            this.icon = 'injured-foot';

            const policyIndex = $stateParams.policyIndex;

            currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                const state = policyInfo.property_data.address.state;

                if (isDp3Policy(policyInfo)) {
                    this.description = `
                        This is the insurance that covers certain instances of bodily injury, personal injury 
                        (emotional or other non-physical damages), medical expenses, and property damage sustained by others for 
                        which you as the property owner is legally responsible.`;
                } else {
                    this.description = `This insurance covers certain instances of bodily injury, personal injury (emotional or 
                        other non-physical damages), medical expenses, and property damage sustained by others for which you or 
                        your family members are legally responsible.`;
                }

                this.coverages = [
                    {
                        name: 'Personal Liability',
                        value: getFormattedPersonalLiabilityCoverageAmount(policyInfo),
                        tooltipContent:
                            state === 'pa'
                                ? `Please note: Hippo policies do not cover liability / medical claims caused by dogs with prior
                                  bite history (see your policy for details).`
                                : `Please note: Hippo policies do not cover liability / medical claims caused by dogs with prior 
                                  bite history or by dogs that classify as any of the following breeds: Akita, Cane Corsos, Chow,
                                  Doberman, Pit Bull (or Pit Bull mix), Presa Canario, Rottweiler, Wolf Hybrid or Wolf Dog, Husky,
                                  German Shepherd, Alaskan Malamute and Great Dane (see your policy for details).`
                    },
                    {
                        name: 'Medical Payment',
                        value: getFormattedMedicalPaymentCoverageAmount(policyInfo)
                    }
                ];
            });
        };
    }
});

export { module };
